module.exports = __webpack_public_path__ + "img/swiper4.ee216db4.jpg";